var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransferCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 8,
    fill: "#D347CE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_709_25696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0942 19.4074C23.195 19.1801 23.25 18.9307 23.25 18.6732V11.3233C23.2494 11.0035 23.1644 10.6894 23.0034 10.4131C22.8424 10.1367 22.6113 9.90771 22.3333 9.7494L15.9167 6.0754C15.6375 5.91592 15.3215 5.83203 15 5.83203C14.6785 5.83203 14.3625 5.91592 14.0833 6.0754L11.3223 7.65665M8.98758 8.99315L7.66667 9.7494C7.09925 10.0748 6.75 10.6752 6.75 11.3242V18.6741C6.75 19.324 7.09925 19.9235 7.66667 20.248L14.0833 23.922C14.3625 24.0815 14.6785 24.1654 15 24.1654C15.3215 24.1654 15.6375 24.0815 15.9167 23.922L20.9987 21.0125",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 24.1667V15",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3203 13.6597L23.0018 10.3799",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99707 10.3799L14.9996 14.9999",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75 6.75L23.25 23.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_709_25696"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransferCube);
export default __webpack_public_path__ + "static/media/TransferCube.cd51d732b903f810eb900fbdd7b6bfb4.svg";
export { ForwardRef as ReactComponent };